import { createYandexMetrikaService } from './create-yandex-metrika-service';
import { IYandexMetrikaInitParams, IYandexMetrikaService } from './types';

interface Options {
    initialParams: IYandexMetrikaInitParams;
    scriptSrc: string;
}

export class MetrikaProvider {
    private metrika: IYandexMetrikaService | null;

    constructor({ initialParams, scriptSrc }: Options) {
        this.metrika = createYandexMetrikaService({ metrikaInitParams: initialParams, scriptSrc });
    }

    trackEvent(eventName: string, params: {}) {
        if (this.metrika) {
            this.metrika.params({
                [eventName]: params,
            });
        }
    }
}
